import { render, staticRenderFns } from "./ProfileDeleteConfirmModal.vue?vue&type=template&id=0c038898&"
import script from "./ProfileDeleteConfirmModal.vue?vue&type=script&lang=js&"
export * from "./ProfileDeleteConfirmModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports